import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageH1 from "@components/seo/PageH1";
const ServiceContent = ({ title, bodyContent }) => {
    return (_jsxs("section", { className: "service-content", children: [_jsx(PageH1, { fallbackElement: "h2", className: "service-content-title", children: title }), _jsx("div", { className: "service-content-body", dangerouslySetInnerHTML: { __html: bodyContent } })] }));
};
export default ServiceContent;
